const stringsComuns = require('./comum');

module.exports = {
    ...stringsComuns,
    adicionarArquivos: 'Adicionar arquivos',
    aguardandoAnalise: 'Aguardando análise',
    aguardandoRevisao: 'Aguardando revisão',
    arquivos: 'Arquivos',
    bloco: 'Bloco',
    blocos: 'Blocos',
    cadastroModeloLaudo: 'Cadastro de modelo de laudo',
    camposNãoPrenchidos: 'Campos obrigatórios não preenchidos.',
    carregandoExame: 'Carregando exame',
    coloracao: 'Coloração',
    dataColeta: 'Data de coleta',
    dataHoraRecebimento: 'Data e hora do recebimento',
    descricao: 'Descrição',
    descricaoColoracao: 'Descrição da coloração',
    descricaoExame: 'Descrição do exame',
    descricaoMetodo: 'Descrição do método',
    descricaoTipo: 'Descrição do tipo',
    descricaoTopologia: 'Descrição da topologia',
    emAnalise: 'Em análise',
    erroSortearExame: 'Não foi possível sortear o próximo exame para laudo. Tente novamente e se o problema persistir, entre em contato com os administradores.',
    envioExame: 'Envio de Exame',
    hipoteseDiagnostica: 'Hipótese diagnóstica',
    historico: 'Histórico',
    historicoClinico: 'Histórico Clínico',
    identificador: 'Identificador',
    identificadorBlocoOrigem: 'Identificador do bloco de origem',
    informacoesGerais: 'Informações gerais',
    proximoExame: 'Próximo exame',
    lamina: 'Lâmina',
    laminas: 'Lâminas',
    laudoRegistrado: 'Laudo registrado',
    laudoPublicado: 'Laudo publicado',
    liberado: 'Liberado',
    macroscopia: 'Macroscopia',
    materiais: 'Materiais',
    materiaisBlocosLaminas: 'Materiais, blocos e lâminas',
    material: 'Material',
    medicamentos: 'Medicamentos',
    mensagemEnviandoExame: 'Enviando exame',
    mensagemCancelarEnvioExame: 'Deseja cancelar o envio do exame?',
    mensagemConfirmarTermo: 'Deseja imprimir o TCLE?',
    metodo: 'Método',
    modeloLaudo: 'Modelos de laudo',
    nenhummExameParaLaudo: 'Nenhum exame disponível para laudo',
    origem: 'Origem',
    simboloAdicao: '+',
    subtipoExame: 'Subtipo de exame',
    tentarNovamente: stringsComuns.tentarNovamente,
    tipoExame: 'Tipo de exame',
    topologia: 'Topologia',
    oQueDesejaFazer: 'O que deseja fazer?',
    substituir: 'Substituir',
    desejaAdicionarOuSubstituir: 'Adicionar ao modelo atual ou substituir o modelo atual?',
};
